import type { CollectionSummaryJSONObject } from '@ikegps/core-api';
import { Services } from '../../services';

export class CollectionInsightProcessModalCtrl {
	collections: CollectionSummaryJSONObject[];

	constructor(collections: CollectionSummaryJSONObject[]) {
		this.collections = collections;
	}

	//we take the departmentId as a parameter to make inter department duplication easier to implement even if it is not currently needed
	async insightProcessCollections() {
		const departmentId = Services.Department.current?.objectId;
		const collectionIds = this.collections.map((c) => c.collectionId);

		if (!departmentId) {
			throw Error('No departmentId found');
		}
		return await Services.Department.rest.Collection.insightProcess({
			departmentId,
			where: { collectionId: { $in: collectionIds } },
			dryRun: false,
		});
	}
}
